// only exists as an alias to allow react-rails UJS to load this component

import EmployeeProfileContainer from "../employee/EmployeeProfileContainer";
export default EmployeeProfileContainer;



// WEBPACK FOOTER //
// ./app/javascript/components/preloaded/EmployeeProfileContainer.tsx